<template>
    <div class="cultivos-wrapper container-fluid">
        <!-- Submenú integrado como pestañas -->
        <div class="subnav-tabs d-flex justify-content-start mb-3">
            <button v-for="opcion in opciones" :key="opcion.nombre" class="tab-btn"
                :class="{ active: componenteActivo === opcion.componente }"
                @click="cambiarComponente(opcion.componente)">
                <font-awesome-icon :icon="opcion.icono" class="me-2" />
                {{ opcion.label }}
            </button>
        </div>

        <!-- Render dinámico del componente -->
        <component :is="componenteActivo" class="componente-cultivo px-3" :proyecto_id="proyectoActualId"
            @proyectoCreado="proyectoCreado" @proyectoSeleccionado="seleccionarProyecto"
            :club_id="club_id" />

    </div>
</template>

<script>
import OperacionDiaria from '@/views/Proyecto/ProyectoGestion.vue';
import PlanificarCultivo from '@/views/PlanCultivo/PlanCultivoGestion.vue';
import CrearCultivo from '@/components/Proyecto/alta-proyecto.vue';
import listarProyectos from '@/components/Proyecto/listar-proyectos.vue';

export default {
    name: 'CultivosWrapper',
    components: {
        OperacionDiaria,
        PlanificarCultivo,
        CrearCultivo,
        listarProyectos
    },
    data() {
        return {
            componenteActivo: 'OperacionDiaria',
            proyectoActualId: null,
            club_id: this.$store.getters.getClubActual?.id || null, // Obtiene el club_id del store
            opciones: [
                { nombre: 'operacion', label: 'Operación Diaria', componente: 'OperacionDiaria', icono: 'leaf' },
                { nombre: 'listarcultivos', label: 'Listar Cultivos', componente: 'listarProyectos', icono: 'list' },
                { nombre: 'crear', label: 'Crear Cultivo', componente: 'CrearCultivo', icono: 'plus-circle' },
                { nombre: 'planificar', label: 'Planificar Cultivo', componente: 'PlanificarCultivo', icono: 'calendar-alt' }
                
            ]
        };
    },
    methods: {
        cambiarComponente(componente) {
            this.componenteActivo = componente;
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        proyectoCreado(proyecto) {
            this.$store.commit('setProyectoActual', proyecto);
            this.proyectoActualId = proyecto.id;
            this.componenteActivo = 'OperacionDiaria';
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        seleccionarProyecto(proyecto) {
            this.proyectoActualId = proyecto.id;
            this.$store.commit('setProyectoActual', proyecto);
            this.componenteActivo = 'OperacionDiaria';
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }



    },
};
</script>

<style scoped>
.cultivos-wrapper {
    padding: 16px;
    width: 100vw; /* Cambiado a 100vw para asegurar que ocupe todo el ancho de la ventana */
    box-sizing: border-box; /* Asegura que el padding no afecte el ancho total */
}

.subnav-tabs {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between; /* Distribuye los botones uniformemente */
    background-color: #f5f5f5;
    padding: 10px 15px;
    border-radius: 6px;
    border: 1px solid #dcdcdc;
    gap: 8px;
}

.tab-btn {
    flex-grow: 1; /* Permite que los botones crezcan para llenar el espacio */
    border: none;
    background-color: transparent;
    padding: 8px 16px;
    border-radius: 6px;
    font-weight: 500;
    color: #3b873e;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center; /* Centra el contenido del botón */
}

.tab-btn:hover {
    background-color: #e0f2e9;
}

.tab-btn.active {
    background-color: #3b873e;
    color: #fff;
    font-weight: bold;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.componente-cultivo {
    padding: 0.5rem;
    margin: 0.5rem auto;
    width: 100%;
}

@media (max-width: 768px) {
    .subnav-tabs {
        flex-direction: column; /* Cambia a columna en pantallas pequeñas */
    }

    .tab-btn {
        margin-bottom: 8px; /* Añade espacio entre botones en columna */
    }
}
</style>
